// extracted by css-extract-rspack-plugin
export default {"dashboardRow__titleClassName":"src-domain-components-dashboard-row-DashboardRow-module__dashboardRow__titleClassName-FCIY2q","dashboardRowTitleClassName":"src-domain-components-dashboard-row-DashboardRow-module__dashboardRow__titleClassName-FCIY2q","dashboardRow__customClassName":"src-domain-components-dashboard-row-DashboardRow-module__dashboardRow__customClassName-fM7x_N","dashboardRowCustomClassName":"src-domain-components-dashboard-row-DashboardRow-module__dashboardRow__customClassName-fM7x_N"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"dashboardRow__titleClassName\":\"src-domain-components-dashboard-row-DashboardRow-module__dashboardRow__titleClassName-FCIY2q\",\"dashboardRowTitleClassName\":\"src-domain-components-dashboard-row-DashboardRow-module__dashboardRow__titleClassName-FCIY2q\",\"dashboardRow__customClassName\":\"src-domain-components-dashboard-row-DashboardRow-module__dashboardRow__customClassName-fM7x_N\",\"dashboardRowCustomClassName\":\"src-domain-components-dashboard-row-DashboardRow-module__dashboardRow__customClassName-fM7x_N\"}";
        // 1793705033223
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  